import { RtColumnCapabilities } from "src/components/ReactiveTable/RtColumn";

export const actionColumnWidth = 48;
export const actionColumnCapabilities = {
  configurable: false,
  resizable: false,
  fixed: "right",
} as const satisfies RtColumnCapabilities;

export const makeRowActionKey = (key: string) => `@action:${key}`;
